import { render, staticRenderFns } from "./lineLIFFApp.vue?vue&type=template&id=2b923d76&"
import script from "./lineLIFFApp.vue?vue&type=script&lang=js&"
export * from "./lineLIFFApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports